<mat-toolbar>
    <span id="card-title" class="title">
        {{ 'DEPLOYMENTS.DEPLOYMENT-SECRETS.TITLE' | translate }}

        <mat-icon>vpn_key</mat-icon></span
    >
</mat-toolbar>

<mat-card>
    <div *ngIf="isLoading" class="spinner spinner_overlay">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>

    <mat-card-header>
        <mat-card-title class="tool-title">
            <h2>{{ data.name }}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content
        [ngClass]="{
            'card-content-mobile': this.mobileQuery.matches
        }"
    >
        <div class="secrets-list">
            <h3 id="subtitle">
                {{ 'DEPLOYMENTS.DEPLOYMENT-SECRETS.LIST' | translate }}
            </h3>
            <div
                *ngFor="let secret of paginatedSecrets"
                [ngClass]="{
                    'secret-item': !mobileQuery.matches,
                    'secret-item-mobile': mobileQuery.matches
                }"
            >
                <mat-form-field
                    class="full-width mr-3"
                    subscriptSizing="dynamic"
                >
                    <mat-label id="secret-name">{{ secret.name }}</mat-label>
                    <input
                        id="secret"
                        matInput
                        [type]="secret.hide ? 'password' : 'text'"
                        disabled="true"
                        value="{{ secret.value }}"
                    />

                    <button
                        id="show-button"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="secret.hide ? 'Show' : 'Hide'"
                        (click)="secret.hide = !secret.hide"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="secret.hide"
                    >
                        <mat-icon
                            color="accent"
                            class="secrets-list-action-icon"
                            >{{
                                secret.hide ? 'visibility_off' : 'visibility'
                            }}</mat-icon
                        >
                    </button>
                </mat-form-field>
                <button
                    id="copy-button"
                    mat-icon-button
                    matTooltip="Copy"
                    class="secrets-list-action-icon"
                    [copy-to-clipboard]="secret.value"
                >
                    <mat-icon matSuffix color="accent"> content_copy</mat-icon>
                </button>
                <button
                    id="delete-button"
                    mat-icon-button
                    matTooltip="Delete"
                    color="warn"
                    class="secrets-list-action-icon"
                    (click)="deleteSecret(secret.name)"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </div>

            <mat-paginator
                #paginator
                *ngIf="secrets.length > 0"
                class="mb-1"
                (page)="handlePageEvent($event)"
                [length]="length"
                [pageSize]="pageSize"
                [disabled]="false"
                [showFirstLastButtons]="true"
                [hidePageSize]="false"
                [pageIndex]="pageIndex"
                aria-label="Select page"
            >
            </mat-paginator>
            <p *ngIf="secrets.length === 0 && !isLoading" class="empty-list">
                {{ 'DEPLOYMENTS.DEPLOYMENT-SECRETS.EMPTY-LIST' | translate }}
            </p>

            <div [formGroup]="secretFormGroup" class="new-secret-item">
                <mat-form-field class="mr-2">
                    <mat-label>
                        {{
                            'DEPLOYMENTS.DEPLOYMENT-SECRETS.NEW-SECRET-NAME'
                                | translate
                        }}</mat-label
                    >
                    <input
                        id="input"
                        matInput
                        type="text"
                        formControlName="secret"
                    />
                    <mat-error
                        *ngIf="
                            secretFormGroup.get('secret')?.errors?.['required']
                        "
                    >
                        {{
                            'DEPLOYMENTS.DEPLOYMENT-SECRETS.REQUIRED-FIELD-ERROR'
                                | translate
                        }}
                    </mat-error>
                    <mat-hint
                        *ngIf="!secretNameIsUnique()"
                        class="mat-mdc-form-field-error"
                    >
                        {{
                            'DEPLOYMENTS.DEPLOYMENT-SECRETS.UNIQUE-NAME-ERROR'
                                | translate
                        }}
                    </mat-hint>
                    <mat-hint
                        *ngIf="
                            secretFormGroup.get('secret')?.touched &&
                            !secretNameIsNotJustWhitespaces()
                        "
                        class="mat-mdc-form-field-error"
                    >
                        {{
                            'DEPLOYMENTS.DEPLOYMENT-SECRETS.WHITESPACES-ERROR'
                                | translate
                        }}
                    </mat-hint>
                </mat-form-field>
                <button
                    id="add-button"
                    mat-raised-button
                    matTooltip="Add"
                    color="accent"
                    class="mr-2 ml-2"
                    disabled="{{
                        secretFormGroup.get('secret')?.errors?.['required'] ||
                            !secretNameIsUnique() ||
                            !secretNameIsNotJustWhitespaces()
                    }}"
                    (click)="addSecret()"
                >
                    <mat-icon iconPositionEnd>add_circle</mat-icon>
                    {{ 'GENERAL-BUTTONS.ADD' | translate }}
                </button>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions align="end" class="actions-container">
        <button
            id="close-button"
            mat-raised-button
            mat-dialog-close
            color=""
            class="mr-2"
        >
            {{ 'GENERAL-BUTTONS.CLOSE' | translate }}
        </button>
    </mat-card-actions>
</mat-card>
